/**
 * Phase 61 Plan 06 — Respect configuration admin page (/admin/respect).
 *
 * Composes:
 *   - CategoryTagEditor: create / rename / disable kudos category tags (D-18/D-20)
 *   - WeightSettingEditor: per-category-tag + per-behaviour-source weight editing (D-18)
 *     with preview-before-save (D-22) and band recompute trigger on save (D-21)
 *
 * D-17 enforcement: NO per-user score history, no "all kudos archive" — this page
 * is configuration-only. Admin sees same band displays on user profiles as peers.
 */
import { CategoryTagEditor } from '../../components/respect/admin/CategoryTagEditor';
import { WeightSettingEditor } from '../../components/respect/admin/WeightSettingEditor';

export default function RespectAdminPage() {
  return (
    <div className="p-6 space-y-8 max-w-4xl">
      <header>
        <h1 className="text-2xl font-semibold text-gray-900">Respect configuration</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage kudos category tags and behaviour-source weights. Changes take effect on future
          kudos and behaviour events only (existing scores are unchanged &mdash; forward-only).
        </p>
      </header>

      <section>
        <h2 className="text-lg font-medium text-gray-800 mb-3">Category tags</h2>
        <p className="text-sm text-gray-500 mb-3">
          Click a label or weight to edit it inline. Disabled tags are hidden from the kudos picker
          but existing kudos that used the tag remain visible on user profiles.
        </p>
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <CategoryTagEditor />
        </div>
      </section>

      <section>
        <h2 className="text-lg font-medium text-gray-800 mb-3">Behaviour-source weights</h2>
        <p className="text-sm text-gray-500 mb-3">
          Set points per event for each behaviour signal. Use &ldquo;Preview&rdquo; to see how a hypothetical
          change would shift the band distribution before committing. &ldquo;Save and trigger recompute&rdquo;
          persists the change and queues a band refresh.
        </p>
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <WeightSettingEditor />
        </div>
      </section>
    </div>
  );
}
